// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1819":"5d8a00c4","6118":"3baa6dd0","7814":"7b89197c","8581":"5d8a00c4"}[chunkId] + ".chunk.css";
};